window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

window.EVASuit.Behaviors = (function(module) {
    "use strict";
    var presentation_stack = [], stack_is_locked = false;

    /**
     * Error that indicates that elements were presented or dismissed in ways
     * that are invalid.
     */
    class PresentationLogicError extends Error {
        constructor(message) {
            super(message);
            this.name = "PresentationLogicError";
        }
    }

    /**
     * Present a given item.
     * 
     * Presentation is hierarchial and follows the DOM tree. We maintain a
     * stack of currently-presented elements. Presenting a new element
     * dismisses all prior elements that are *not* parents of the current one.
     * 
     * Clicking, focusing, tabbing, or ESCing out of the presented element
     * automatically dismisses it.
     * 
     * To respond to presentation and dismissal, implement the presented() and
     * dismissed() methods of your Behavior.
     * 
     * @param {Behaviors.Behavior} item A located behavior to present to
     * the user.
     */
    function present(item) {
        var stack_cleaned = false, i;
        
        if (stack_is_locked) {
            throw new PresentationLogicError("Cannot present items recursively.");
        }

        stack_is_locked = true;

        // Dismiss presented elements off the stack until we catch one that is
        // a parent of the item to be presented.
        while (presentation_stack.length > 0 && !stack_cleaned) {
            var iter = item.elem;

            while (iter !== undefined) {
                if (presentation_stack[presentation_stack.length - 1] === iter) {
                    stack_cleaned = true;
                    break;
                }

                iter = iter.parent;
            }

            try {
                presentation_stack.pop().dismissed();
            } catch (e) {
                stack_is_locked = false;
                throw e;
            }
        }
        
        presentation_stack.push(item);
        
        try {
            item.presented();
        } finally {
            stack_is_locked = false;
        }
    }

    /**
     * Dismiss a given item.
     * 
     * All presented children of this item will also be dismissed.
     * 
     * @param {Behaviors.Behavior} [item] A located behavior to dismiss.
     * 
     * If not provided, the last presented item on the stack will be dismissed.
     */
    function dismiss(item) {
        var stack_index, i = 0;
        
        if (stack_is_locked) {
            throw new PresentationLogicError("Cannot dismiss items recursively.");
        }

        if (presentation_stack.length === 0) {
            throw new PresentationLogicError("Cannot dismiss without presenting first.");
        }

        if (item === undefined) {
            stack_index = presentation_stack.length - 1;
            item = presentation_stack[stack_index];
        } else {
            stack_index = presentation_stack.indexOf(item);
        }

        if (stack_index === -1) {
            throw new PresentationLogicError("Cannot dismiss elements that were not presented.");
        }
        
        while (presentation_stack.length > stack_index) {
            try {
                presentation_stack.pop().dismissed();
            } catch (e) {
                stack_is_locked = false;
                throw e;
            }
        }

        stack_is_locked = false;
    }

    /**
     * Present or dismiss an item based on if it is already presented.
     * 
     * @param {Behaviors.Behavior} item A located behavior to toggle.
     */
    function toggle(item) {
        if (presentation_stack.indexOf(item) !== -1) {
            dismiss(item);
        } else {
            present(item);
        }
    }

    document.addEventListener("keyup", function(evt) {
        if (evt.isComposing || evt.keyCode === 229) {
            // Ignore all composition events caused by IMEs (Input Method
            // Editors, used for Chinese, Japanese, Korean, etc) on desktop.
            return;
        }

        if (evt.key === "Esc" || evt.key === "Escape" || evt.keyCode === 27) {
            if (presentation_stack.length > 0) {
                dismiss();
            }
        }
    });

    module.present = present;
    module.dismiss = dismiss;
    module.toggle = toggle;

    return module;
}(window.EVASuit.Behaviors));